import type { Selector, State as S } from 'model/State';

export const selectCurrency: Selector<string[]> = (state: S) =>
  state.mac.currency.currencyList?.ifSuccess((r) => r) || [];
